import { View, Text, useWindowDimensions } from 'tamagui'
import { useWatermarkPosition } from '@hooks/useWatermarkPosition'
import { useMemo } from 'react'

interface IWatermarkProps {
  isPlaying: boolean
  isFullScreenMode: boolean
  watermarkText: string
}

const SPACING = 16

const POSITIONS = {
  topLeft: {
    top: SPACING,
    left: SPACING,
  },
  topRight: {
    top: SPACING,
    right: SPACING,
  },
  bottomLeft: {
    bottom: SPACING,
    left: SPACING,
  },
  bottomRight: {
    bottom: SPACING,
    right: SPACING,
  },
}

export const Watermark = ({
  isPlaying,
  isFullScreenMode,
  watermarkText,
}: IWatermarkProps) => {
  const position = useWatermarkPosition(isPlaying)
  const { width, height } = useWindowDimensions()

  const isLandscape = useMemo(() => {
    return width > height
  }, [width, height])

  const FULL_SCREEN_POSITIONS = useMemo(() => {
    const positionHeight = 360
    const positionWidth = isLandscape ? 250 : 16
    return {
      topLeft: {
        top: positionHeight,
        left: positionWidth,
      },
      topRight: {
        top: positionHeight,
        right: positionWidth,
      },
      bottomLeft: {
        bottom: positionHeight,
        left: positionWidth,
      },
      bottomRight: {
        bottom: positionHeight,
        right: positionWidth,
      },
    }
  }, [isLandscape])

  const getPositionStyles = () => {
    return isFullScreenMode
      ? FULL_SCREEN_POSITIONS[position]
      : POSITIONS[position]
  }

  return (
    <View
      position="absolute"
      zIndex={2}
      maxWidth={150}
      testID="watermark-container"
      {...getPositionStyles()}
    >
      <Text
        color="$cross-white"
        ff="$mulishBold"
        fontSize="$font-size-xxxs"
        opacity={0.3}
        fontWeight="800"
        testID="watermark-text"
      >
        {watermarkText}
      </Text>
    </View>
  )
}
